import EfModal from '@elem/ui/ef-modal';
import { useState } from 'react';
import styles from './index.module.scss';
import Modal from './Modal';
import { useLang } from '@/i18n';
const icon = (
    <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="36" height="36" rx="18" fill="url(#paint0_linear_1272_6517011)" />
        <path d="M25.2833 18.5001H10.7167" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18 11.2168V25.7834" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <defs>
            <linearGradient id="paint0_linear_1272_6517011" x1="5.07599e-06" y1="5.30002" x2="26.6868" y2="-1.27879" gradientUnits="userSpaceOnUse">
                <stop stopColor="#3F68E0" />
                <stop offset="1" stopColor="#7D9DFC" />
            </linearGradient>
        </defs>
    </svg>
);
export default function BtnWithWin() {
    const { t } = useLang('theProduct.NonstopPower');
    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        setShowModal(true);

        window?.dataLayer?.push({
            event: 'uaEvent',
            event_name: 'product_details',
            button_name: t('btn1'),
        });
    };
    return (
        <div className={styles.TheComp}>
            <button className="btn" onClick={openModal}>
                <span className="text">{t('btn1')}</span>
                {icon}
            </button>
            {showModal && (
                <EfModal position="center" open={showModal} className="modal" callback={() => setShowModal(false)}>
                    <Modal />
                </EfModal>
            )}
        </div>
    );
}
